import React, { useEffect, useState } from "react";
import CountUp from "react-countup";

import { Container } from "./styles";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";
import Status from "../../../components/status";
import {
  Card,
  HeaderTitle,
  Message,
  Table,
  ViewInput,
} from "../../../GlobalStyles";

import { getDate, getValue, phoneFormat } from "../../../services/functions";
import { addDays, format } from "date-fns";
import {
  Button,
  Pagination,
  Spin,
  DatePicker,
  Select,
  Modal,
  Tooltip,
} from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import { useQuery } from "../../../hooks/Location";
import {
  MdAccountBalance,
  MdClose,
  MdMail,
  MdPhone,
  MdVisibility,
  MdLocationOn,
  MdBusiness,
  MdGroup,
  MdAssignment,
} from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { Label, AssociateInfo, InfoTag } from "./styles";
import { ContainerLead } from "../Leads/styles";
import userPhoto from "../../../images/user.png";

const PagamentosAdmin = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const [users, setUsers] = useState([]);
  const [payments, setPayments] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [paymentsTotal, setPaymentsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [user_id, setUser_id] = useState(query.get("cliente") || "");
  const [status, setStatus] = useState("");
  const [method, setMethod] = useState("");
  const [type, setType] = useState("");
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  const [visibleDepositModal, setVisibleDepositModal] = useState(false);
  const [selectedDeposit, setSelectedDeposit] = useState(null);
  const [visibleLeadModal, setVisibleLeadModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  useEffect(() => {
    loadPayments(page);
  }, [page, user_id, status, method, type, startDate, endDate]);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadLeadDetails(id) {
    setIsLoadingDetails(true);
    setSelectedLead(null);
    setVisibleLeadModal(true);
    await api
      .get(`/leadmaster/${id}`)
      .then((response) => {
        setSelectedLead(response.data);
      })
      .catch(({ response }) => {
        toast.error("Erro ao carregar dados do lead");
        setVisibleLeadModal(false);
      });
    setIsLoadingDetails(false);
  }

  async function loadDepositDetails(id) {
    setIsLoadingDetails(true);
    setSelectedDeposit(null);
    setVisibleDepositModal(true);
    await api
      .get(`/deposit/${id}`)
      .then((response) => {
        setSelectedDeposit(response.data);
      })
      .catch(({ response }) => {
        toast.error("Erro ao carregar dados do depósito");
        setVisibleDepositModal(false);
      });
    setIsLoadingDetails(false);
  }

  async function loadUsers() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadPayments(page) {
    setIsLoading(true);
    let url = `/admin/payments?page=${page}`;
    if (user_id) url += `&user_id=${user_id}`;
    if (status) url += `&status=${status}`;
    if (method) url += `&method=${method}`;
    if (type) url += `&type=${type}`;
    if (startDate && endDate) {
      url += `&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
    }

    console.log(url);

    await api
      .get(url)
      .then((response) => {
        setPayments(response.data.payments);
        setTotalValue(response.data.totalValue);
        setPaymentsTotal(response.data.paymentsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Todos Pagamentos</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => {
            navigate("/admin/pacotes");
          }}
        >
          <MdAccountBalance size="20" color="#fff" />
          Pacotes de Deposito
        </Button>
      </HeaderTitle>

      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={paymentsTotal} />
          </Card>

          <div className="filters-row">
            <ViewInput style={{ width: "100%", maxWidth: 265 }}>
              <p>Selecione o Periodo</p>
              <DatePicker.RangePicker
                placeholder={["data inicial", "data final"]}
                value={[
                  startDate ? dayjs(startDate) : "",
                  endDate ? dayjs(endDate) : "",
                ]}
                locale={locale}
                format={"DD/MM/YYYY"}
                onChange={(value) => {
                  if (value) {
                    setStartDate(value[0].toDate());
                    setEndDate(value[1].toDate());
                  }
                  setPage(0);
                }}
                allowClear={false}
              />
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 200 }}>
              <p>Filtrar por Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Franqueados</Select.Option>
                {users.map((item) => {
                  return (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 150 }}>
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="pendente">Pendente</Select.Option>
                <Select.Option value="confirmado">Confirmado</Select.Option>
                <Select.Option value="cancelado">Cancelado</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 150 }}>
              <p>Filtrar por Método</p>
              <Select
                placeholder="selecionar método"
                value={method}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setMethod(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="PIX">PIX</Select.Option>
                <Select.Option value="SALDO">Saldo</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 175 }}>
              <p>Filtrar por Tipo</p>
              <Select
                placeholder="selecionar tipo"
                value={type}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setType(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="OS">Ordem de Serviço</Select.Option>
                <Select.Option value="LEAD">Compra de Lead</Select.Option>
                <Select.Option value="DEPOSIT">Deposito de Saldo</Select.Option>
              </Select>
            </ViewInput>
          </div>

          {!!totalValue && (
            <h4 style={{ marginTop: 10, marginBottom: 10, color: "#008037" }}>
              Total em pagamentos: {getValue(totalValue)}
            </h4>
          )}

          <div className="payments-list">
            {paymentsTotal ? (
              payments.map((payment) => (
                <div className="payment-card" key={payment.id}>
                  <div className="main-info">
                    <strong>
                      {payment.type === "OS"
                        ? `OS: ${payment.order_id}`
                        : payment.type === "LEAD"
                          ? `COMPRA DE LEAD`
                          : "DEPÓSITO DE SALDO"}
                    </strong>
                    <span>Transação</span>
                  </div>

                  <div className="info-item">
                    <label>Valor</label>
                    <span style={{ color: "#008037", fontWeight: "bold" }}>
                      {getValue(payment.value)}
                    </span>
                  </div>

                  <div className="info-item">
                    <label>Método</label>
                    <span style={{ textTransform: "uppercase" }}>
                      {payment.method}
                    </span>
                  </div>

                  <div className="info-item">
                    <label>Status</label>
                    <Status
                      status={payment.status}
                      isPayment={true}
                      style={{
                        fontSize: 10,
                        height: 18,
                        paddingBottom: 2,
                        width: "fit-content",
                      }}
                    />
                  </div>

                  <div className="info-item">
                    <label>Atualização</label>
                    <span>
                      {format(new Date(payment.update_at), "dd/MM/yyyy HH:mm")}
                    </span>
                  </div>

                  <div className="actions">
                    <Tooltip title="Ver Detalhes">
                      <Button
                        shape="circle"
                        icon={<MdVisibility size={18} />}
                        onClick={() => {
                          if (payment.type == "OS") {
                            navigate(`/admin/os/${payment.order_id}`);
                          } else if (payment.type == "LEAD") {
                            loadLeadDetails(payment.lead_id);
                          } else if (payment.type == "DEPOSIT") {
                            loadDepositDetails(payment.deposit_id);
                          }
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  background: "#fff",
                  padding: 50,
                  borderRadius: 15,
                  textAlign: "center",
                  border: "1px solid #eee",
                }}
              >
                <Message>Nenhum pagamento encontrado.</Message>
              </div>
            )}
          </div>
        </>
      )}

      <Pagination
        style={{ marginTop: 25, alignSelf: "center" }}
        current={page + 1}
        onChange={(p) => {
          setPage(p - 1);
        }}
        total={paymentsTotal}
        pageSize={30}
      />

      <Modal
        title={"Detalhes do Depósito"}
        open={visibleDepositModal}
        onCancel={() => setVisibleDepositModal(false)}
        footer={[
          <Button key="back" onClick={() => setVisibleDepositModal(false)}>
            FECHAR
          </Button>,
        ]}
        width={500}
      >
        {isLoadingDetails ? (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <Spin size="large" />
          </div>
        ) : (
          selectedDeposit && (
            <div style={{ padding: "10px 0" }}>
              <div style={{ marginBottom: 20 }}>
                <h3
                  style={{
                    borderBottom: "1px solid #eee",
                    paddingBottom: 5,
                    fontSize: 16,
                  }}
                >
                  Informações do Depósito
                </h3>
                <p style={{ margin: "5px 0" }}>
                  <strong>Nome:</strong> {selectedDeposit.name}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Descrição:</strong>{" "}
                  {selectedDeposit.description || "Sem Descrição"}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Valor:</strong> {getValue(selectedDeposit.value || 0)}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Bônus:</strong> {getValue(selectedDeposit.bonus || 0)}
                </p>
                <p
                  style={{
                    margin: "5px 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <strong>Status:</strong>{" "}
                  <Status
                    status={selectedDeposit.status}
                    isPayment={true}
                    style={{
                      marginLeft: 10,
                      fontSize: 11,
                      height: 20,
                      paddingBottom: 2,
                    }}
                  />
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Data:</strong>{" "}
                  {format(
                    new Date(selectedDeposit.update_at),
                    "dd/MM/yyyy HH:mm",
                  )}
                </p>
              </div>
              <div>
                <h3
                  style={{
                    borderBottom: "1px solid #eee",
                    paddingBottom: 5,
                    fontSize: 16,
                  }}
                >
                  Informações do Usuário
                </h3>
                <p style={{ margin: "5px 0" }}>
                  <strong>Nome:</strong> {selectedDeposit.user.name}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Email:</strong> {selectedDeposit.user.email}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Telefone:</strong>{" "}
                  {selectedDeposit.user.phone_number
                    ? phoneFormat(selectedDeposit.user.phone_number)
                    : "Não informado"}
                </p>
              </div>
            </div>
          )
        )}
      </Modal>

      <Modal
        width={500}
        open={visibleLeadModal}
        onCancel={() => setVisibleLeadModal(false)}
        footer={null}
        closable={false}
        styles={{ content: { padding: 0 } }}
      >
        {isLoadingDetails ? (
          <div style={{ textAlign: "center", padding: "50px 0" }}>
            <Spin size="large" color="#008037" />
          </div>
        ) : (
          selectedLead && (
            <div
              style={{
                position: "relative",
                background: "#fff",
                borderRadius: 5,
                padding: "25px 20px 20px 20px",
                borderTop: "30px solid #d7f0db",
              }}
            >
              <MdClose
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: -25,
                  right: 10,
                }}
                size={20}
                color="#333"
                onClick={() => setVisibleLeadModal(false)}
              />
              <header
                style={{
                  position: "absolute",
                  top: -22,
                  left: 15,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Label color={"#008037"} />
                <p
                  style={{
                    marginLeft: 5,
                    fontSize: 12,
                    fontWeight: 500,
                    color: "#000a",
                  }}
                >
                  Detalhes do Lead
                </p>
              </header>

              <h2 style={{ marginTop: 10, fontSize: 22 }}>
                {selectedLead.name}
              </h2>

              <InfoTag>
                {selectedLead.email && (
                  <div className="tag">
                    <MdMail size={14} /> {selectedLead.email}
                  </div>
                )}
                {selectedLead.phone_number && (
                  <div className="tag">
                    <MdPhone size={14} /> {selectedLead.phone_number}
                  </div>
                )}
                {selectedLead.location && (
                  <div className="tag">
                    <MdLocationOn size={14} /> {selectedLead.location}
                  </div>
                )}
                {selectedLead.cnpj && (
                  <div className="tag">
                    <MdBusiness size={14} /> CNPJ: {selectedLead.cnpj}
                  </div>
                )}
                {selectedLead.employees && (
                  <div className="tag">
                    <MdGroup size={14} /> {selectedLead.employees} func.
                  </div>
                )}
                {selectedLead.necessity && (
                  <div className="tag">
                    <MdAssignment size={14} /> {selectedLead.necessity}
                  </div>
                )}
              </InfoTag>

              <div style={{ margin: "15px 0" }}>
                <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
                  Observações do Cadastro:
                </p>
                <p
                  style={{ fontSize: 14, fontWeight: "normal", color: "#333" }}
                >
                  {selectedLead.observation || "Sem observações adicionais."}
                </p>
              </div>

              <div
                style={{
                  background: "#f9f9f9",
                  padding: 15,
                  borderRadius: 10,
                  margin: "15px 0",
                }}
              >
                <p style={{ fontSize: 12, color: "#888", margin: 0 }}>
                  Valor Estimado:
                </p>
                <p
                  style={{
                    fontSize: 20,
                    color: "#008037",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                >
                  {getValue(selectedLead.value || 0)}
                </p>
              </div>

              <div style={{ display: "flex", gap: 15, marginTop: 10 }}>
                {selectedLead.phone_number && (
                  <FaWhatsapp
                    size={22}
                    color="#25D366"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      window.open(
                        `https://api.whatsapp.com/send/?phone=55${selectedLead.phone_number}`,
                      )
                    }
                  />
                )}
                {selectedLead.phone_number && (
                  <MdPhone
                    size={22}
                    color="#333"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      window.open(`tel:${selectedLead.phone_number}`)
                    }
                  />
                )}
                {selectedLead.email && (
                  <MdMail
                    size={22}
                    color="#EA4335"
                    style={{ cursor: "pointer" }}
                    onClick={() => window.open(`mailto:${selectedLead.email}`)}
                  />
                )}
              </div>

              {selectedLead.associate && (
                <AssociateInfo>
                  <img
                    src={
                      selectedLead.associate.photo
                        ? selectedLead.associate.photo_url
                        : userPhoto
                    }
                    alt="Perfil"
                  />
                  <div className="info">
                    <span>Indicado por:</span>
                    <strong>{selectedLead.associate?.name}</strong>
                  </div>
                </AssociateInfo>
              )}
            </div>
          )
        )}
      </Modal>
    </Container>
  );
};

export default PagamentosAdmin;
